"use client";

import React from "react";
import { ErrorBoundary } from "../ErrorBoundary";
import { sendError } from "../ErrorBoundary/helpers";
import { Slider } from "../Slider";
import { useFavorites } from "./hooks";
import { FavoriteItem } from "./item";
import styles from "./styles.module.scss";

export const Favorites: React.FC = () => {
    const favorites = useFavorites();

    try {
        return (
            <Slider minHeight="60px">
                <div className={styles.wrapper}>
                    {favorites.map((fav) => (
                        <ErrorBoundary key={fav.code}>
                            <FavoriteItem
                                code={fav.code}
                                totalAmount={favorites.length}
                            />
                        </ErrorBoundary>
                    ))}
                </div>
            </Slider>
        );
    } catch (e) {
        sendError(e);
        return null;
    }
};
